/**
 * @fileoverview Противообледенительная обработка бортов.
 */

import { Snd } from "../audio/sound";
import { frontStage } from "../state/createGame";
import type { GameHooks, GameState, Plane } from "../state/types";
import { rnd } from "../util/math";
import { addScore } from "./scoring";

/** При жесткой погоде потребовать обработку перед вылетом. */
export function maybeRequireDeice(g: GameState, hooks: GameHooks, p: Plane): void {
  if (!p || p.deiceT > 0 || p.deiceWaive) return;
  const ice = Math.max(g.runways[0]?.ice || 0, g.runways[1]?.ice || 0);
  const stage = frontStage(g).id;
  const need =
    ice > 32 || stage === "peak" || (stage === "build" && ice > 18) || g.vis > 0.32;
  if (p.deiced) {
    if (!(need && ice > 55 && stage === "peak")) return;
    p.deiced = false;
  }
  if (
    need &&
    (p.status === "service" ||
      p.status === "ready" ||
      p.status === "hold_short")
  ) {
    if (!p.needsDeice) {
      p.needsDeice = true;
      hooks.toast(
        `${p.cs}: нужна обработка от обледенения перед вылетом (карточка борта)`,
        "wx",
      );
      hooks.invalidateCard?.();
    }
  }
}

/** Начать обработку борта. */
export function cmdDeice(g: GameState, hooks: GameHooks, p: Plane): void {
  if (!p) return;
  if (p.deiced) {
    hooks.toast(`${p.cs} уже обработан`);
    return;
  }
  if (p.deiceT > 0) {
    hooks.toast(`${p.cs}: обработка уже идет`);
    return;
  }
  if (
    !(
      p.status === "ready" ||
      p.status === "hold_short" ||
      p.status === "service"
    )
  ) {
    hooks.toast("Обработка доступна у гейта / перед вылетом", "bad");
    return;
  }
  const dur = 3.2 / (g.cfg?.plow || 1);
  p.needsDeice = true;
  p.deiceWaive = false;
  p.deiceT = dur;
  p.deiceMax = dur;
  hooks.toast(`${p.cs}: обработка от обледенения · ~${Math.ceil(dur)}с`);
  Snd.ok();
}

/** Тик таймеров обработки. */
export function updatePlaneCare(
  g: GameState,
  hooks: GameHooks,
  dt: number,
): void {
  for (const p of g.planes) {
    if (p.deiceT > 0) {
      p.deiceT -= dt;
      if (Math.random() < 0.35) {
        g.sparks.push({
          x: p.x + rnd(-18, 18),
          y: p.y + rnd(-10, 10),
          vx: rnd(-15, 15),
          vy: rnd(-35, -8),
          t: rnd(0.2, 0.45),
          c: "rgba(200,170,255,.9)",
          s: rnd(1, 2.2),
        });
      }
      if (p.deiceT <= 0) {
        p.deiceT = 0;
        p.deiced = true;
        p.needsDeice = false;
        hooks.toast(`${p.cs} обработан — можно выпускать`, "good");
        addScore(g, hooks, 45, p, "ОБРАБОТКА ПО");
        Snd.ok();
        hooks.invalidateCard?.();
      }
    }
  }
}
